<template>
  <div v-if="isActive" class="fixed inset-0 z-overlay">
    <div
      class="absolute inset-0 bg-cBlack opacity-20"
      @click="emit('click:outside', $event)"
    ></div>
    <div :class="contentClasses">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    isActive: boolean;
    contentPosition?: 'center' | 'bottom';
  }

  const props = withDefaults(defineProps<Props>(), {
    isActive: true,
    contentPosition: 'center',
  });

  const emit = defineEmits<{
    (e: 'click:outside', value: MouseEvent): void;
  }>();

  const contentClasses = computed(() => {
    const baseClasses =
      'absolute left-1/2 max-h-[80vh] w-[calc(100%_-_44px)] translate-x-[-50%]';

    if (props.contentPosition === 'bottom') {
      return `${baseClasses} bottom-[20%]`;
    }

    return `${baseClasses} top-1/2 translate-y-[-50%]`;
  });
</script>
